// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_Page{
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    padding: 5.5rem 20rem 0rem 20rem;
    min-height: calc(100vh - 3rem - 16vh);
}
.Form_LoginPage{
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 3rem 1rem;
    width: 60%;
    background-color:  rgba(0,0,0,0.19);
    border-radius: 10px;
}
.form-groupDashboard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.form-groupDashboard >input {
    display: flex;
    border: 1px solid rgba(0,0,0,0.8) !important;
    width: 70%;
    padding: 10px 5px;
    border-radius: 5px;
    margin-bottom: 15px;
    background-color: transparent;
    font-size: medium;
}
p>a{
    color: var(--bg-grey);
    letter-spacing: 0rem;
}
.btnDashboard {
    padding: 10px 20px;
    background-color: var(--bg-grey);
    color: var(--bg-black);
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
}
@media screen and (max-width: 1200px){
    .login_Page{
        padding: 3rem 5rem;
    }
}
@media screen and (max-width: 800px){
    .login_Page{
        padding: 3rem 1rem;
    }
}
@media screen and (max-width: 500px){
    .login_Page{
        padding: 3rem 0rem;
    }
    .Form_LoginPage{
        width: 80%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Register/Register.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;IAChC,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,mCAAmC;IACnC,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,4CAA4C;IAC5C,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".login_Page{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    /* justify-content: center; */\n    padding: 5.5rem 20rem 0rem 20rem;\n    min-height: calc(100vh - 3rem - 16vh);\n}\n.Form_LoginPage{\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    padding: 3rem 1rem;\n    width: 60%;\n    background-color:  rgba(0,0,0,0.19);\n    border-radius: 10px;\n}\n.form-groupDashboard {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.form-groupDashboard >input {\n    display: flex;\n    border: 1px solid rgba(0,0,0,0.8) !important;\n    width: 70%;\n    padding: 10px 5px;\n    border-radius: 5px;\n    margin-bottom: 15px;\n    background-color: transparent;\n    font-size: medium;\n}\np>a{\n    color: var(--bg-grey);\n    letter-spacing: 0rem;\n}\n.btnDashboard {\n    padding: 10px 20px;\n    background-color: var(--bg-grey);\n    color: var(--bg-black);\n    font-size: 16px;\n    font-weight: 700;\n    cursor: pointer;\n}\n@media screen and (max-width: 1200px){\n    .login_Page{\n        padding: 3rem 5rem;\n    }\n}\n@media screen and (max-width: 800px){\n    .login_Page{\n        padding: 3rem 1rem;\n    }\n}\n@media screen and (max-width: 500px){\n    .login_Page{\n        padding: 3rem 0rem;\n    }\n    .Form_LoginPage{\n        width: 80%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
